import { PieceTypeModel } from './piece-type.model';
import { DimensionsModel } from './dimensions.model';

export default class PieceModel {
  /**
     *
     * @param type
     * @param dimensions
     * @param weight
     */
  constructor(
    type = PieceTypeModel.createPieceTypeModel(0),
    dimensions = new DimensionsModel(),
    weight = Number(),
  ) {
    if (type instanceof PieceTypeModel) {
      this.type = type;
    } else {
      this.type = PieceTypeModel.createPieceTypeModel(0);
    }
    if (dimensions instanceof DimensionsModel) {
      this.dimensions = dimensions;
    } else {
      this.dimensions = new DimensionsModel();
    }
    if (typeof weight === 'number') {
      this.weight = weight;
    } else {
      this.weight = Number();
    }
  }
}
